/**
 * The strategic rows behind M2's market tab (M4 plan I6, spec §15 item 3): the Wire feature installs a source
 * (the strategic market's cached `StationView` rows); M2's market model asks it for a ware's row at the docked
 * station and adds the stock bar, trend and cause chip. With no source (the sandbox, M2's stand-in economy) the
 * rows stay as M2 drew them. UI events only.
 */
import type { MarketRow } from '../../strategic/types'
import { rowEconomy, type RowEconomy } from './causeModel'

/** Station id (M2's or the strategic one) → its market rows. */
export type MarketRowSource = (stationId: string) => readonly MarketRow[]

let source: MarketRowSource | null = null

/** Installs (or with null removes) the source; returns a function that restores the previous one. */
export function setMarketRowSource(next: MarketRowSource | null): () => void {
  const previous = source
  source = next
  return () => {
    source = previous
  }
}

/** The strategic row of `ware` at `stationId`, or null. */
export function strategicRow(stationId: string, ware: string): MarketRow | null {
  if (source === null) return null
  const rows = source(stationId)
  for (let i = 0; i < rows.length; i++) if (rows[i].ware === ware) return rows[i]
  return null
}

/** The stock bar, trend and cause chip of `ware` at `stationId`, or undefined outside the strategic economy. */
export function rowEconomyAt(stationId: string, ware: string): RowEconomy | undefined {
  const row = strategicRow(stationId, ware)
  return row === null ? undefined : rowEconomy(row)
}
